export default "__VITE_ASSET__y0tU2TfP__"